import { Link } from "@inertiajs/react";
import type { ColumnDef } from "@tanstack/react-table";
import { Eye } from "lucide-react";

import { Button } from "@/components/ui/button";
import { DataTableColumnHeader } from "@/lib/data-table-column-header";
import { organizationCompanyPath } from "@/routes";
import type { Company } from "@/types";

const formatFiscalStatus = (status?: string | null) => {
  if (!status) return "-";
  return status.replace(/_/g, " ");
};

export const buildColumns = (
  organizationSlug: string,
): ColumnDef<Company>[] => [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    enableSorting: false,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Nombre" />
    ),
    enableSorting: false,
  },
  {
    accessorKey: "tax_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="CUIT" />
    ),
    enableSorting: false,
    cell: ({ row }) => row.original.tax_id ?? <span className="text-muted-foreground">-</span>,
  },
  {
    accessorKey: "legal_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Razón social" />
    ),
    enableSorting: false,
    cell: ({ row }) => row.original.legal_name ?? <span className="text-muted-foreground">-</span>,
  },
  {
    accessorKey: "fiscal_status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Condición fiscal" />
    ),
    enableSorting: false,
    cell: ({ row }) => (
      <span className="capitalize">
        {formatFiscalStatus(row.original.fiscal_status)}
      </span>
    ),
  },
  {
    id: "actions",
    header: "Acciones",
    cell: ({ row }) => {
      const company = row.original;

      return (
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link href={organizationCompanyPath(organizationSlug, company)}>
              <Eye className="h-4 w-4" />
              Ver
            </Link>
          </Button>
        </div>
      );
    },
  },
];
